<template>
<div>

<div class="card text-black mb-1 mt-1">
<div  class="card-header bg-light">
    <h4><i class="far fa-file-pdf mr-2 bold" aria-hidden="true"></i>DOCUMENTO DI CARICO (FATTURA/DDT)</h4>

     <form> 
    <collectionSelect  v-bind:props="collection" @update="setCollectionId"></collectionSelect>     
    <div class="form-inline" >

<div class="form-group">
    <label for="number_doc"><strong>Numero documento</strong></label>
    <input  @change="$emit('update',document)"  v-model="document.number" type="text" class="form-control ml-3 mr-3" placeholder="" name="number_doc" id = "number_doc" required>
</div>

<div class="form-group">
    <label for="date_doc"><strong>Data documento</strong></label>
    <input  @change="$emit('update',document)" required v-model="document.date" type="date" class="form-control ml-3 mr-3" placeholder="" name="date_doc" id = "date_doc">
</div>

<div class="form-group">
  <label for="doc_type" ><strong>Tipo documento</strong></label>
  <select @change="$emit('update',document)" required v-model="document.typeId" class="form-control ml-3 mr-3" id="doc_type">
    <option value="1">Fattura</option>
    <option value="2">DDT</option>
  </select>
</div>
</div>
</form>


</div>
</div>

<!-- MAIN DIV -->
</div>

</template>
<script>
import collectionSelect        from '@/components/common/CollectionSelect_1.vue' 


export default {
  
  components: {collectionSelect
  
  },  
  props: ['doc'],

  data () {
    return {
      
      document  : {},
      collection           : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        

      },
      
    }
  },


created()
{ 
  if(this.doc)
  {
    this.collection.Id = this.doc.collectionId
    
  }
  else
  {
    
    this.document.collectionId = 0
    
  }
  this.document = this.doc
  this.$emit('update',this.document)

  
},

methods:
{

  setCollectionId(Id)
    { 
      
      this.document.collectionId = Id
      this.$emit('update',this.document)
    },

    
}
    
}    
</script>

<style scoped>
 
.bold {
  font-weight  : bolder;
  
}

h4 {
  color        :rgb(114, 52, 7) ;
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
  font-weight  : bold;
}



</style>